import { createContext } from 'react';
import { AxiosInstance } from 'axios';

const ApiClientContext = createContext<AxiosInstance | null>(null);

export default ApiClientContext;
